import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';
import borders from 'assets/theme/base/borders';
import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { common } = colors;
const { size, fontWeightMedium } = typography;
const { borderRadius } = borders;

const outlined = {
    base: {
        '&:hover': {
            opacity: 0.75,
        },
    },

    small: {},

    medium: {
        //height: pxToRem(34),
        padding: `${pxToRem(7)} ${pxToRem(22)}`,
        borderRadius: borderRadius.md,
        fontSize: size.md,
        fontWeight: fontWeightMedium,

        [breakpoints.down('md')]: {
            padding: `${pxToRem(7)} ${pxToRem(18)}`,
            fontSize: size.sm,
        },

        [breakpoints.down('sm')]: {
            padding: `${pxToRem(7)} ${pxToRem(10)}`,
            fontSize: size.xs,
        },
    },

    large: {},

    primary: {
        backgroundColor: colors.info.dark,
        color: common.white,
        borderColor: common.white,
    },

    secondary: {},
};

export default outlined;
